export default {
    // 设置当前登录的用户信息
    setUserInfo(state, payload) {
        state.userInfo = payload;
    },
    // 设置菜单
    setMenu(state, payload) {
        state.menuList = payload;
    },
    // 设置菜单按钮权限
    setKeys(state, payload) {
        state.keys = payload;
    },
};
